import { useState, useCallback } from 'react';
import { isTokenExpired } from '../context/AuthContext';

interface UseAuthTokenCheckResult {
  validateToken: () => { isValid: boolean; token: string | null };
  showSessionExpiredDialog: boolean;
  setShowSessionExpiredDialog: (show: boolean) => void;
}

/**
 * Hook to check authentication token validity
 * Returns validation function and dialog state
 */
export const useAuthTokenCheck = (): UseAuthTokenCheckResult => {
  const [showSessionExpiredDialog, setShowSessionExpiredDialog] = useState(false);

  const validateToken = useCallback((): { isValid: boolean; token: string | null } => {
    // Get authguard token from localStorage
    const token = typeof window !== 'undefined' ? localStorage.getItem('authguard_access_token') : null;
    
    if (!token) {
      setShowSessionExpiredDialog(true);
      return { isValid: false, token: null };
    }

    // Check if token is expired
    if (isTokenExpired(token)) {
      setShowSessionExpiredDialog(true);
      return { isValid: false, token };
    }

    return { isValid: true, token };
  }, []);

  return {
    validateToken,
    showSessionExpiredDialog,
    setShowSessionExpiredDialog,
  };
};

